import { Inject, Injectable } from '@angular/core';
import {
  UrlTree,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  NavigationEnd,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, TOKEN } from '@/app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '@/app/shared/services/common.service';
import { DOCUMENT } from '@angular/common';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { TransferState } from '@angular/core';
import { AccountService } from '@/app/shared/services/account.service';

@Injectable({
  providedIn: 'root',
})
export class AccountGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService,
    private cookieService: SsrCookieService,
    @Inject(DOCUMENT) private document: Document,
    private transferState: TransferState,
    private accountService: AccountService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Redirect to the login page
    // const localStorage = this.document.defaultView?.localStorage;
    // const token = this.cookieService.get('token');
    const token = this.cookieService.get('token');
    if (!token) {
      this.accountService.returnUrl = state.url;
      return this.router.navigateByUrl('/auth/login', { replaceUrl: true });
    }

    return true;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    // const token = this.cookieService.get('token');
    const token = this.cookieService.get('token');
    if (!token) {
      this.accountService.returnUrl = state.url;
      this.router.navigate(['/auth/login']);
      return false;
    }
    return true;
  }
}
